import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { HRServices } from "./HRService";
import { toast } from "react-toastify";
import { successAlert } from "../Global/GlobalSlice";

export const GetRSA = createAsyncThunk(
  "hr/GetRsa",

  async (payload, { rejectWithValue, getState, dispatch }) => {
    console.log(payload);
    try {
      const response = await HRServices.hrService().GetRSA(payload);
      console.log(response.data);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllPayroll = createAsyncThunk(
  "hr/GetAllPayrollRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllPayroll(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApprovePayroll = createAsyncThunk(
  "hr/ApprovePayroll",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApprovePayroll(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetDocumentDifinition = createAsyncThunk(
  "hr/GetDocumentDifinition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetDocumentDifinition(
        payload
      );
      // console.log("payroll Data", response?.data);
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetDocumentDifinitionById = createAsyncThunk(
  "hr/GetDocumentDifinitionById",
  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetDocumentDifinitionById(
        id
      );
      // console.log("payroll Data", response?.data);
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclinePayroll = createAsyncThunk(
  "hr/DeclinePayroll",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclinePayroll(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelPayroll = createAsyncThunk(
  "hr/CancelPayroll",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CancelPayroll(payload);
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSinglePayroll = createAsyncThunk(
  "hr/GetSinglePayroll",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSinglePayroll(payload);
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdatePayrollSetup = createAsyncThunk(
  "hr/MyUpdatePayrollSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().MyUpdatePayrollSetup(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//loan

export const GetLoanSetup = createAsyncThunk(
  "hr/GetLoanSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetLoanSetup(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateLoan = createAsyncThunk(
  "hr/CreateLoan",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateLoan(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateLoan = createAsyncThunk(
  "hr/UpdateLoan",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateLoan(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteLoan = createAsyncThunk(
  "hr/DeleteLoan",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeleteLoan(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//loan Rule

export const GetLoanRuleSetup = createAsyncThunk(
  "hr/GetLoanRuleSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetLoanRuleSetup(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateLoanRule = createAsyncThunk(
  "hr/CreateLoanRule",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateLoanRule(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateLoanRule = createAsyncThunk(
  "hr/UpdateLoanRule",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateLoanRule(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteLoanRule = createAsyncThunk(
  "hr/DeleteLoanRule",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeleteLoanRule(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Medical Starts

export const GetAllHospital = createAsyncThunk(
  "hr/GetAllHospital",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllHospital(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateHospital = createAsyncThunk(
  "hr/CreateHospital",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateHospital(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleHospital = createAsyncThunk(
  "hr/GetSingleHospital",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleHospital(payload);
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateHospital = createAsyncThunk(
  "hr/UpdateHospital",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateHospital(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveHospital = createAsyncThunk(
  "hr/ApproveHospital",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveHospital(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineHospital = createAsyncThunk(
  "hr/DeclineHospital",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineHospital(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelHospital = createAsyncThunk(
  "hr/DeclineHospital",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().DeclineHospital(payload);
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
//

//Medical Limit Setup Starts

export const GetAllMedicalLimit = createAsyncThunk(
  "hr/GetAllMedicalLimit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllMedicalLimit(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateMedicalLimit = createAsyncThunk(
  "hr/CreateMedicalLimit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateMedicalLimit(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleMedicalLimit = createAsyncThunk(
  "hr/GetSingleMedicalLimit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleMedicalLimit(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateMedicalLimit = createAsyncThunk(
  "hr/UpdateMedicalLimit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateMedicalLimit(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveMedicalLimit = createAsyncThunk(
  "hr/ApproveMedicalLimit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveMedicalLimit(
        payload
      );
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineMedicalLimit = createAsyncThunk(
  "hr/DeclineMedicalLimit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineMedicalLimit(
        payload
      );

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelMedicalLimit = createAsyncThunk(
  "hr/CancelMedicalLimit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CancelMedicalLimit(payload);
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveApplication = createAsyncThunk(
  "hr/ApproveApplication",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveApplication(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineApplication = createAsyncThunk(
  "hr/DeclineApplication",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineApplication(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelApplication = createAsyncThunk(
  "hr/CancelApplication",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CancelApplication(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Loan Requisition

export const GetAllLoanRequisition = createAsyncThunk(
  "hr/GetAllLoanRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllLoanRequisition(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateLoanRequisition = createAsyncThunk(
  "hr/CreateLoanRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateLoanRequisition(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleLoanRequisition = createAsyncThunk(
  "hr/GetSingleLoanRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleLoanRequisition(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateLoanRequisition = createAsyncThunk(
  "hr/UpdateLoanRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateLoanRequisition(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveLoanRequisition = createAsyncThunk(
  "hr/ApproveLoanRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveLoanRequisition(
        payload
      );
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineLoanRequisition = createAsyncThunk(
  "hr/DeclineLoanRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineLoanRequisition(
        payload
      );

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelLoanRequisition = createAsyncThunk(
  "hr/CancelLoanRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CancelLoanRequisition(
        payload
      );
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveMetric = createAsyncThunk(
  "hr/ApproveMetric",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveMetric(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineMetric = createAsyncThunk(
  "hr/DeclineMetric",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineMetric(payload);
      //console.log(response.data)
      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelMetric = createAsyncThunk(
  "hr/CancelMetric",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CancelMetric(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveJob = createAsyncThunk(
  "hr/ApproveJob",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveJob(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineJob = createAsyncThunk(
  "hr/DeclineJob",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineJob(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelJob = createAsyncThunk(
  "hr/CancelJob",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CancelJob(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveSkill = createAsyncThunk(
  "hr/ApproveSkill",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveSkill(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineSkill = createAsyncThunk(
  "hr/DeclineSkill",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineSkill(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelSkill = createAsyncThunk(
  "hr/CancelSkill",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CancelSkill(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveQualification = createAsyncThunk(
  "hr/ApproveQualification",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveQualification(
        payload
      );
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineQualification = createAsyncThunk(
  "hr/DeclineQualification",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineQualification(
        payload
      );
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelQualification = createAsyncThunk(
  "hr/CancelQualification",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CancelQualification(
        payload
      );
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetEmployeeGroup = createAsyncThunk(
  "hr/GetEmployeeGroupRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEmployeeGroup(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveEmployeeGroup = createAsyncThunk(
  "hr/ApproveEmployeeGroup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveEmployeeGroup(
        payload
      );
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeGroup = createAsyncThunk(
  "hr/DeclineEmployeeGroup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineEmployeeGroup(
        payload
      );
      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelEmployeeGroup = createAsyncThunk(
  "hr/CancelEmployeeGroup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CancelEmployeeGroup(
        payload
      );
      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateEmployeeGroup = createAsyncThunk(
  "hr/CreateEmployeeGroup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateEmployeeGroup(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdateEmployeeGroup = createAsyncThunk(
  "hr/MyUpdateEmployeeGroup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().MyUpdateEmployeeGroup(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//new row

export const GetEmployeeCadrePosition = createAsyncThunk(
  "hr/GetEmployeeCadrePosition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEmployeeCadrePosition(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetEmployeeCadreLevels = createAsyncThunk(
  "hr/GetEmployeeCadreLevels",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEmployeeCadreLevels(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveEmployeeCadrePosition = createAsyncThunk(
  "hr/ApproveEmployeeCadrePosition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().ApproveEmployeeCadrePosition(payload);
      //console.log(response.data)
      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );
      toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeCadrePosition = createAsyncThunk(
  "hr/DeclineEmployeeCadrePosition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().DeclineEmployeeCadrePosition(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelEmployeeCadrePosition = createAsyncThunk(
  "hr/CancelEmployeeCadrePosition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CancelEmployeeCadrePosition(
        payload
      );
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateEmployeeCadrePosition = createAsyncThunk(
  "hr/CreateEmployeeCadrePosition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateEmployeeCadrePosition(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdateEmployeeCadrePosition = createAsyncThunk(
  "hr/MyUpdateEmployeeCadrePosition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().MyUpdateEmployeeCadrePosition(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleEmployeeCadrePosition = createAsyncThunk(
  "hr/GetSingleEmployeeCadrePosition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response =
        await HRServices.hrService().GetSingleEmployeeCadrePosition(payload);
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleEmployeeCadrePositionLevel = createAsyncThunk(
  "hr/GetSingleEmployeeCadrePositionLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response =
        await HRServices.hrService().GetSingleEmployeeCadrePositionLevel(
          payload
        );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetDepartment = createAsyncThunk(
  "hr/GetDepartment",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetDepartment(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Another new row

export const GetEmployeeCadrePositionLevel = createAsyncThunk(
  "hr/GetEmployeeCadrePositionLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetEmployeeCadrePositionLevel(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveEmployeeCadrePositionLevel = createAsyncThunk(
  "hr/ApproveEmployeeCadrePositionLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().ApproveEmployeeCadrePositionLevel(payload);
      //console.log(response.data)
      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeCadrePositionLevel = createAsyncThunk(
  "hr/DeclineEmployeeCadrePositionLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().DeclineEmployeeCadrePositionLevel(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelEmployeeCadrePositionLevel = createAsyncThunk(
  "hr/CancelEmployeeCadrePositionLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response =
        await HRServices.hrService().CancelEmployeeCadrePositionLevel(payload);
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateEmployeeCadrePositionLevel = createAsyncThunk(
  "hr/CreateEmployeeCadrePositionLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().CreateEmployeeCadrePositionLevel(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdateEmployeeCadrePositionLevel = createAsyncThunk(
  "hr/MyUpdateEmployeeCadrePositionLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().MyUpdateEmployeeCadrePositionLevel(
          payload
        );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//new row

export const GetPayrollStructure = createAsyncThunk(
  "hr/GetPayrollStructure",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetPayrollStructure(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApprovePayrollStructure = createAsyncThunk(
  "hr/ApprovePayrollStructure",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApprovePayrollStructure(
        payload
      );
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclinePayrollStructure = createAsyncThunk(
  "hr/DeclinePayrollStructure",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclinePayrollStructure(
        payload
      );

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelPayrollStructure = createAsyncThunk(
  "hr/CancelPayrollStructure",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CancelPayrollStructure(
        payload
      );
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreatePayrollStructure = createAsyncThunk(
  "hr/CreatePayrollStructure",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreatePayrollStructure(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdatePayrollStructure = createAsyncThunk(
  "hr/MyUpdatePayrollStructure",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().MyUpdatePayrollStructure(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSinglePayrollStructure = createAsyncThunk(
  "hr/GetSinglePayrollStructure",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSinglePayrollStructure(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// **************Weekend Allowance*********************
export const GetAllWeekendAllowance = createAsyncThunk(
  "hr/GetAllWeekendAllowance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetAllWeekendAllowanceWorkflow(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllWeekendAllowanceByDepartment = createAsyncThunk(
  "hr/GetAllWeekendAllowance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetAllWeekendAllowanceByDepartment(
          payload
        );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveWeekendAllowance = createAsyncThunk(
  "hr/ApproveWeekendAllowance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveWeekendAllowance(
        payload
      );
      //console.log(response.data)
      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );
      //toast.success(response?.data?.statusMessage);
      console.log("response");
      console.log("response", response);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineWeekendAllowance = createAsyncThunk(
  "hr/DeclineWeekendAllowance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineWeekendAllowance(
        payload
      );

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelWeekendAllowance = createAsyncThunk(
  "hr/CancelWeekendAllowance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CancelWeekendAllowance(
        payload
      );
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateWeekendAllowance = createAsyncThunk(
  "hr/CreateWeekendAllowance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateWeekendAllowance(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateMyWeekendAllowance = createAsyncThunk(
  "hr/UpdateMyWeekendAllowance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateMyWeekendAllowance(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetMyWeekendAllowance = createAsyncThunk(
  "hr/GetMyWeekendAllowance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetMyWeekendAllowance(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getSingleWeekendAllowance = createAsyncThunk(
  "hr/getSingleWeekendAllowance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().getSingleWeekendAllowance(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllWeekendAllowanceSetup = createAsyncThunk(
  "hr/GetAllWeekendAllowanceSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllWeekendAllowanceSetup(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateWeekendAllowanceSetup = createAsyncThunk(
  "hr/CreateWeekendAllowanceSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateWeekendAllowanceSetup(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateWeekendAllowanceSetup = createAsyncThunk(
  "hr/UpdateWeekendAllowanceSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateWeekendAllowanceSetup(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteWeekendAllowanceSetup = createAsyncThunk(
  "hr/DeleteWeekendAllowanceSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeleteWeekendAllowanceSetup(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// **************************************************

export const SubmitRepaymentPlanSetup = createAsyncThunk(
  "hr/SubmitRepaymentPlanSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().SubmitRepaymentPlanSetup(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateRepaymentPlanSetup = createAsyncThunk(
  "hr/UpdateRepaymentPlanSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateRepaymentPlanSetup(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteRepaymentPlanSetup = createAsyncThunk(
  "hr/DeleteRepaymentPlanSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeleteRepaymentPlanSetup(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllRepaymentPlanSetup = createAsyncThunk(
  "hr/GetAllRepaymentPlanSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllRepaymentPlanSetup(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetRepaymentPlanSetupById = createAsyncThunk(
  "hr/GetRepaymentPlanSetupById",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetRepaymentPlanSetupById(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// ApproveAuxiliaryServiceSetup
export const ApproveRepaymentPlanSetup = createAsyncThunk(
  "hr/ApproveRepaymentPlanSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveRepaymentPlanSetup(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// **************** Booking Service *********************

export const SubmitBookingService = createAsyncThunk(
  "hr/SubmitBookingService",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().SubmitBookingService(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteBookingService = createAsyncThunk(
  "hr/DeleteBookingService",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeleteBookingService(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllBookingService = createAsyncThunk(
  "hr/GetAllBookingService",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllBookingService(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetBookingServiceById = createAsyncThunk(
  "hr/GetBookingServiceById",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetBookingServiceById(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateBookingService = createAsyncThunk(
  "hr/UpdateBookingService",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateBookingService(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// **************************************************

export const SubmitAuxiliaryServiceSetup = createAsyncThunk(
  "hr/SubmitAuxiliaryServiceSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().SubmitAuxiliaryServiceSetup(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateAuxiliaryServiceSetup = createAsyncThunk(
  "hr/UpdateAuxiliaryServiceSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateAuxiliaryServiceSetup(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteAuxiliaryServiceSetup = createAsyncThunk(
  "hr/DeleteAuxiliaryServiceSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeleteAuxiliaryServiceSetup(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllAuxiliaryServiceSetup = createAsyncThunk(
  "hr/GetAllAuxiliaryServiceSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllAuxiliaryServiceSetup(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAuxiliaryServiceSetupById = createAsyncThunk(
  "hr/GetAuxiliaryServiceSetupById",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetAuxiliaryServiceSetupById(payload);
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// ApproveAuxiliaryServiceSetup
export const ApproveAuxiliaryServiceSetup = createAsyncThunk(
  "hr/ApproveAuxiliaryServiceSetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().ApproveAuxiliaryServiceSetup(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// **************************************************

export const SubmitAuxiliaryServiceRequest = createAsyncThunk(
  "hr/SubmitAuxiliaryServiceRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().SubmitAuxiliaryServiceRequest(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Query/assetDamages
export const submitQueryAssetDamage = createAsyncThunk(
  "hr/submitQueryAssetDamage",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().submitQueryAssetDamage(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// getAllQueryAssetDamage
export const getAllQueryAssetDamage = createAsyncThunk(
  "hr/getAllQueryAssetDamage",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().getAllQueryAssetDamage(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// getSingleQueryAssetDamage
export const getSingleQueryAssetDamage = createAsyncThunk(
  "hr/getSingleQueryAssetDamage",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().getSingleQueryAssetDamage(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// updateQueryAssetDamage
export const updateQueryAssetDamage = createAsyncThunk(
  "hr/updateQueryAssetDamage",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().updateQueryAssetDamage(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// deleteQueryAssetDamage
export const deleteQueryAssetDamage = createAsyncThunk(
  "hr/deleteQueryAssetDamage",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().deleteQueryAssetDamage(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// approveQueryAssetDamage
export const approveQueryAssetDamage = createAsyncThunk(
  "hr/approveQueryAssetDamage",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().approveQueryAssetDamage(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// declineQueryAssetDamage
export const declineQueryAssetDamage = createAsyncThunk(
  "hr/declineQueryAssetDamage",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().declineQueryAssetDamage(
        payload
      );
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// **************************************************

export const UpdateAuxiliaryServiceRequest = createAsyncThunk(
  "hr/UpdateAuxiliaryServiceRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().UpdateAuxiliaryServiceRequest(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteAuxiliaryServiceRequest = createAsyncThunk(
  "hr/DeleteAuxiliaryServiceRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().DeleteAuxiliaryServiceRequest(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllAuxiliaryServiceRequest = createAsyncThunk(
  "hr/GetAllAuxiliaryServiceRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetAllAuxiliaryServiceRequest(payload);
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAuxiliaryServiceRequestById = createAsyncThunk(
  "hr/GetAuxiliaryServiceRequestById",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetAuxiliaryServiceRequestById(payload);
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveAuxiliaryServiceRequest = createAsyncThunk(
  "hr/ApproveAuxiliaryServiceRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().ApproveAuxiliaryServiceRequest(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineAuxiliaryServiceRequest = createAsyncThunk(
  "hr/DeclineAuxiliaryServiceRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().DeclineAuxiliaryServiceRequest(payload);
      console.log(response.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// **************************************************

//Medical Requisition
export const GetEmployeeMedicalRequisition = createAsyncThunk(
  "hr/GetEmployeeMedicalRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetEmployeeMedicalRequisition(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveEmployeeMedicalRequisition = createAsyncThunk(
  "hr/ApproveEmployeeMedicalRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().ApproveEmployeeMedicalRequisition(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeMedicalRequisition = createAsyncThunk(
  "hr/DeclineEmployeeMedicalRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().DeclineEmployeeMedicalRequisition(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelEmployeeMedicalRequisition = createAsyncThunk(
  "hr/CancelEmployeeMedicalRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response =
        await HRServices.hrService().CancelEmployeeMedicalRequisition(payload);
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateEmployeeMedicalRequisition = createAsyncThunk(
  "hr/CreateEmployeeMedicalRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().CreateEmployeeMedicalRequisition(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdateEmployeeMedicalRequisition = createAsyncThunk(
  "hr/MyUpdateEmployeeMedicalRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().MyUpdateEmployeeMedicalRequisition(
          payload
        );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleEmployeeMedicalRequisition = createAsyncThunk(
  "hr/GetSingleEmployeeMedicalRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response =
        await HRServices.hrService().GetSingleEmployeeMedicalRequisition(
          payload
        );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Payment Requisition

export const GetPaymentRequisition = createAsyncThunk(
  "hr/GetPaymentRequisition",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await HRServices.hrService().GetPaymentRequisition(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetPaymentRequisitionWorkflow = createAsyncThunk(
  "hr/GetPaymentRequisitionWorkflow",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await HRServices.hrService().GetPaymentRequisitionWorkflow(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetPaymentRequisitionByUUID = createAsyncThunk(
  "hr/GetPaymentRequisitionByUUID",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetPaymentRequisitionUUID(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetEDSPaymentRequisition = createAsyncThunk(
  "hr/GetPaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEDSPaymentRequisition(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetControlPaymentRequisition = createAsyncThunk(
  "hr/GetControlPaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetControlPaymentRequisition(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetMyPaymentRequisition = createAsyncThunk(
  "hr/GetPaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetMyPaymentRequisition(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApprovePaymentRequisition = createAsyncThunk(
  "hr/ApprovePaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    console.log("Approval-Payload", payload);
    try {
      const response = await HRServices.hrService().ApprovePaymentRequisition(
        payload
      );
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclinePaymentRequisition = createAsyncThunk(
  "hr/DeclinePaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclinePaymentRequisition(
        payload
      );

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelPaymentRequisition = createAsyncThunk(
  "hr/CancelPaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CancelPaymentRequisition(
        payload
      );
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreatePaymentRequisition = createAsyncThunk(
  "hr/CreatePaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreatePaymentRequisition(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdatePaymentRequisition = createAsyncThunk(
  "hr/MyUpdatePaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().MyUpdatePaymentRequisition(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSinglePaymentRequisition = createAsyncThunk(
  "hr/GetSinglePaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSinglePaymentRequisition(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// PaymentRequisition
export const PaymentRequisition = createAsyncThunk(
  "hr/PaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().PaymentRequisition(payload);
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Applicant

export const GetApplicant = createAsyncThunk(
  "hr/GetApplicant",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetApplicant(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const AcceptOffer = createAsyncThunk(
  "hr/AcceptOffer",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().AcceptOffer(payload);
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const RejectOffer = createAsyncThunk(
  "hr/RejectOffer",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().RejectOffer(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CloseOffer = createAsyncThunk(
  "hr/CloseOffer",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CloseOffer(payload);
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateApplicant = createAsyncThunk(
  "hr/CreateApplicant",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateApplicant(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdateApplicant = createAsyncThunk(
  "hr/MyUpdateApplicant",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().MyUpdateApplicant(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleApplicant = createAsyncThunk(
  "hr/GetSingleApplicant",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleApplicant(payload);
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const SigninApplicant = createAsyncThunk(
  "hr/SigninApplicant",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().SigninApplicant(payload);
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Directorate

export const GetDirectorate = createAsyncThunk(
  "hr/GetDirectorate",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetDirectorate(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateDirectorate = createAsyncThunk(
  "hr/CreateDirectorate",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateDirectorate(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdateDirectorate = createAsyncThunk(
  "hr/MyUpdateDirectorate",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().MyUpdateDirectorate(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleDirectorate = createAsyncThunk(
  "hr/GetSingleDirectorate",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleDirectorate(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAttendanceClock = createAsyncThunk(
  "hr/GetAttendanceClock",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAttendanceClock(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdateAttendanceClock = createAsyncThunk(
  "hr/MyUpdateAttendanceClock",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().MyUpdateAttendanceClock(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetJobTitle = createAsyncThunk(
  "hr/GetJobTitle",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetJobTitle(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetJobListing = createAsyncThunk(
  "hr/GetJobListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetJobListing(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// GetSingleJobListing
export const GetSingleJobListing = createAsyncThunk(
  "hr/GetSingleJobListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleJobListing(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateJobListing = createAsyncThunk(
  "hr/CreateJobListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateJobListing(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateJobListing = createAsyncThunk(
  "hr/UpdateJobListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateJobListing(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveJobListing = createAsyncThunk(
  "hr/ApproveJobListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveJobListing(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineJobListing = createAsyncThunk(
  "hr/DeclineJobListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineJobListing(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelJobListing = createAsyncThunk(
  "hr/CancelJobListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CancelJobListing(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ScheduleTnterviewWithCandidate = createAsyncThunk(
  "hr/ScheduleTnterviewWithCandidate",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().ScheduleTnterviewWithCandidate(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const RescheduleTnterviewWithCandidate = createAsyncThunk(
  "hr/RescheduleTnterviewWithCandidate",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().RescheduleTnterviewWithCandidate(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MoveCandidateToSelected = createAsyncThunk(
  "hr/MoveCandidateToSelected",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().MoveCandidateToSelected(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveAttachApplicantToCadreLevel = createAsyncThunk(
  "hr/ApproveAttachApplicantToCadreLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().ApproveAttachApplicantToCadreLevel(
          payload
        );
      return response?.data;
      //console.log(response.data)
    } catch (error) {
      // toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineAttachApplicantToCadreLevel = createAsyncThunk(
  "hr/DeclineAttachApplicantToCadreLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().DeclineAttachApplicantToCadreLevel(
          payload
        );
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UploadAppilcantMedicalForm = createAsyncThunk(
  "hr/UploadMedicalForm",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UploadAppilcantMedicalForm(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// GetJobOffer
export const GetJobOffer = createAsyncThunk(
  "hr/GetJobOffer",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetJobOffer(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// AcceptJobOffer
export const AcceptJobOffer = createAsyncThunk(
  "hr/AcceptJobOffer",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().AcceptJobOffer(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// RejectJobOffer
export const RejectJobOffer = createAsyncThunk(
  "hr/RejectJobOffer",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().RejectJobOffer(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const AssignEmployeesToGrade = createAsyncThunk(
  "hr/AssignEmployeesToGrade",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().AssignEmployeesToGrade(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const submitApplicantGrade = createAsyncThunk(
  "hr/submitApplicantGrade",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().submitApplicantGrade(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const AttachApplicantToCadreLevel = createAsyncThunk(
  "hr/AttachApplicantToCadreLevel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().AttachApplicantToCadreLevel(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateJobTitle = createAsyncThunk(
  "hr/CreateJobTitle",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateJobTitle(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleJobTitle = createAsyncThunk(
  "hr/GetSingleJobTitle",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleJobTitle(payload);
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateJobTitle = createAsyncThunk(
  "hr/UpdateJobTitle",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateJobTitle(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//ExtendedHMOClaims

export const GetExtendedHMOClaims = createAsyncThunk(
  "hr/GetExtendedHMOClaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetExtendedHMOClaims(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveExtendedHMOClaims = createAsyncThunk(
  "hr/ApproveExtendedHMOClaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveExtendedHMOClaims(
        payload
      );
      //console.log(response.data)
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      //toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineExtendedHMOClaims = createAsyncThunk(
  "hr/DeclineExtendedHMOClaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineExtendedHMOClaims(
        payload
      );

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelExtendedHMOClaims = createAsyncThunk(
  "hr/CancelExtendedHMOClaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().CancelExtendedHMOClaims(
        payload
      );
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateExtendedHMOClaims = createAsyncThunk(
  "hr/CreateExtendedHMOClaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateExtendedHMOClaims(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateCreditFacility = createAsyncThunk(
  "hr/CreateCreditFacility",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateCreditFacility(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateCreditFacility = createAsyncThunk(
  "hr/CreateCreditFacility",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateCreditFacility(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const MyUpdateExtendedHMOClaims = createAsyncThunk(
  "hr/MyUpdateExtendedHMOClaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().MyUpdateExtendedHMOClaims(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleExtendedHMOClaims = createAsyncThunk(
  "hr/GetSingleExtendedHMOClaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleExtendedHMOClaims(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//skills starts here

export const GetSkills = createAsyncThunk(
  "hr/GetSkills",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetSkills(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateSkills = createAsyncThunk(
  "hr/CreateSkills",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateSkills(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleSkill = createAsyncThunk(
  "hr/GetSingleSkill",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleSkill(payload);
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateSkills = createAsyncThunk(
  "hr/UpdateSkills",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateSkills(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//qualification starts here

export const GetQualifications = createAsyncThunk(
  "hr/GetQualifications ",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetQualifications(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateQualifications = createAsyncThunk(
  "hr/CreateQualifications",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateQualifications(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleQualification = createAsyncThunk(
  "hr/GetSingleQualification",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleQualification(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateQualifications = createAsyncThunk(
  "hr/UpdateQualifications",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateQualifications(
        payload
      );
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//metrics command starts here

export const GetMetrics = createAsyncThunk(
  "hr/GetMetrics ",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetMetrics(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateMetrics = createAsyncThunk(
  "hr/CreateMetrics",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateMetrics(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleMetrics = createAsyncThunk(
  "hr/GetSingleMetrics",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleMetrics(payload);
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateMetrics = createAsyncThunk(
  "hr/UpdateMetrics",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateMetrics(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//application channel starts here

export const GetApplication = createAsyncThunk(
  "hr/GetApplication",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetApplication(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateApplication = createAsyncThunk(
  "hr/CreateApplication",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateApplication(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleApplication = createAsyncThunk(
  "hr/GetSingleApplication",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log(payload);
    try {
      const response = await HRServices.hrService().GetSingleApplication(
        payload
      );
      console.log(response);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateApplication = createAsyncThunk(
  "hr/UpdateApplication",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateApplication(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllEmployees = createAsyncThunk(
  "hr/GetAllEmployees",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllEmployees(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetAllReferees = createAsyncThunk(
  "hr/Getallreferees",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllReferees(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetLeaveTypes = createAsyncThunk(
  "hr/GetLeaveTypes",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetLeaveTypes(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetLeaveReasons = createAsyncThunk(
  "hr/GetLeaveReasons",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetLeaveReasons(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateLeaveType = createAsyncThunk(
  "hr/CreateLeaveType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateLeaveType(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const AddConsent = createAsyncThunk(
  "/palliative",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().AddConsent(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateLeaveType = createAsyncThunk(
  "hr/UpdateLeaveType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateLeaveType(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreatePayroll = createAsyncThunk(
  "hr/CreatePayroll",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreatePayroll(payload);
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateAttendanceClock = createAsyncThunk(
  "hr/CreateAttendanceClock",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateAttendanceClock(
        payload
      );
      console.log(response.data);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllDepartments = createAsyncThunk(
  "hr/GetDepartments",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllDepartments(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetSingleDepartment = createAsyncThunk(
  "hr/GetSingleDepartments",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetSingleDepartment(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetUnits = createAsyncThunk(
  "hr/GetUnits",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetUnits(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateLeaveRequest = createAsyncThunk(
  "hr/CreateLeaveRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateLeaveRequest(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      } else {
        toast.error(response?.data?.statusMessage);
      }
      return response?.data;
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateLeaveRequest = createAsyncThunk(
  "hr/UpdateLeaveRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    console.log(payload, "PAYLOAD");
    try {
      const response = await HRServices.hrService().UpdateLeaveRequest(payload);
      //console.log(response)
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleLeaveRequest = createAsyncThunk(
  "hr/GetSingleLeaveRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload);
      const response = await HRServices.hrService().GetSingleLeaveRequest(
        payload
      );
      console.log(response?.data);
      // if (response?.data?.successful === true) {
      //   dispatch(
      //     successAlert({
      //       message: response?.data?.statusMessage,
      //     })
      //   );
      // }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetMyLeaveRequest = createAsyncThunk(
  "hr/MyLeaveRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().GetMyLeaveRequest(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetAllLeaveRequest = createAsyncThunk(
  "hr/AllLeaveRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().GetAllLeaveRequest(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetByDepartment = createAsyncThunk(
  "hr/GetByDepartment",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().GetByDepartment(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const ApproveLeave = createAsyncThunk(
  "hr/ApproveLeave",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().ApproveLeave(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const DeclineLeave = createAsyncThunk(
  "hr/DeclineLeave",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log(payload);
      const response = await HRServices.hrService().DeclineLeave(payload);
      console.log(response.data);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelLeave = createAsyncThunk(
  "hr/CancelLeave",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().CancelLeave(payload);

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const ApproveOrDecline = createAsyncThunk(
  "hr/ApproveOrDecline",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveOrDecline(payload);
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateLeaveRecall = createAsyncThunk(
  "hr/createRecall",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    console.log(payload);
    try {
      const response = await HRServices.hrService().CreateLeaveRecall(payload);

      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleLeaveRecall = createAsyncThunk(
  "hr/GetSingleRecall",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetSingleLeaveRecall(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveLeaveRecall = createAsyncThunk(
  "hr/ApproveLeaveRecall",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().ApproveLeaveRecall(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const RejectLeaveRecall = createAsyncThunk(
  "hr/RejectLeaveRecall",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().RejectLeaveRecall(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelLeaveRecall = createAsyncThunk(
  "hr/CancelLeaveRecall",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().CancelLeaveRecall(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetConfirmAction = createAsyncThunk(
  "hr/GetConfirmAction",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetConfirmAction(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Exit management starts here

export const CreateExitRequisition = createAsyncThunk(
  "hr/createExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log(payload);

      const response = await HRServices.hrService().CreateExitRequisition(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      if (response?.data?.successful === false) {
        toast.error(response?.data?.statusMessage);
      }
      return response?.data;

      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );
      // return response?.data;
    } catch (error) {
      console.log("error", error);
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const UpdateExitRequisition = createAsyncThunk(
  "hr/updateExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log(payload);

      const response = await HRServices.hrService().UpdateExitRequisition(
        payload
      );
      // console.log(response.data);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetExitRequisition = createAsyncThunk(
  "hr/getExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetExitRequisition(payload);
      return response?.data;
    } catch (error) {
      console.log("error");
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetMyExitRequisition = createAsyncThunk(
  "hr/getMyExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetMyExitRequisition(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetExitRequisitionHOD = createAsyncThunk(
  "hr/getHODExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetExitRequisitionHOD(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetSingleExitRequisition = createAsyncThunk(
  "hr/getSingleExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetSingleExitRequisition(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveExit = createAsyncThunk(
  "hr/ApproveExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().ApproveExit(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelExit = createAsyncThunk(
  "hr/ApproveExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().CancelExit(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineExit = createAsyncThunk(
  "hr/DeclineExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().DeclineExit(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Exit management ends here

//Exit Discussion
export const CreateExitDiscussionQuestions = createAsyncThunk(
  "hr/createDiscussionQuestions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().CreateExitDiscussionQuestions(payload);

      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const EnableDisableExitDiscussionQuestions = createAsyncThunk(
  "hr/enableDisableDiscussionQuestions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().EnabledDisableExitDiscussionQuestions(
          payload
        );
      console.log("response", response);
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateExitDiscussionQuestions = createAsyncThunk(
  "hr/updateExitDiscussionQuestions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().UpdateExitDiscussionQuestions(payload);
      console.log(response);
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateExitDiscussion = createAsyncThunk(
  "hr/createDiscussion",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateExitDiscussion(
        payload
      );
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetExitDiscussionQuestion = createAsyncThunk(
  "hr/getDiscussionQuestion",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetExitDiscussionQuestion(
        payload
      );

      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetExistDiscussionById = createAsyncThunk(
  "hr/getDiscussionById",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetExistDiscussionById(
        payload
      );

      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetExitDiscussion = createAsyncThunk(
  "hr/getDiscussion",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetExitDiscussion(payload);
      // console.log(response)
      // dispatch(
      //   successAlert({
      //     message: response?.data?.statusMessage,
      //   })
      // );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const AddRemarks = createAsyncThunk(
  "hr/addRemark",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().AddDiscussionRemarks(
        payload
      );

      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//End Exit Discussion

//start Query setup

export const GetQuerySetup = createAsyncThunk(
  "hr/getQuerySetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetQuerySetup(payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateQuerySetup = createAsyncThunk(
  "hr/createQuerySetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateQuerySetup(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateQuerySetup = createAsyncThunk(
  "hr/createQuerySetup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateQuerySetup(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//end query setup

//start query management(panel)
export const GetQueries = createAsyncThunk(
  "hr/getQueries",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetQueries(payload);
      //console.log(response)
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateQueryPanel = createAsyncThunk(
  "hr/createPanel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateQueryPanel(payload);
      console.log(response);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreatePanelReport = createAsyncThunk(
  "hr/createPanelReport",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateQueryReport(payload);
      console.log(response);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetQueryManagement = createAsyncThunk(
  "hr/getQuerymanagement",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetQueryManagement(payload);
      console.log(response);

      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleQueryManagement = createAsyncThunk(
  "hr/getSingleQuerymanagement",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetSingleQueryManagement(
        payload
      );
      console.log(response);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetSingleQuery = createAsyncThunk(
  "hr/getSingleQuery",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetSingleQuery(payload);
      console.log(response);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateQueryPanel = createAsyncThunk(
  "hr/updateQueryPanel",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateQueryPanel(payload);
      console.log(response);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApprovePanelReport = createAsyncThunk(
  "hr/ApproveReport",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().ApprovePanelReport(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const RejectPanelReport = createAsyncThunk(
  "hr/ApproveExit",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().RejectPanelReport(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// end query magement

//start overtime setup
export const GetOvertimeType = createAsyncThunk(
  "hr/getOvertimeType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetOvertimeType(payload);

      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// export const GetEmployeeCadrePosition = createAsyncThunk(
//   "hr/getCadrePosition",
//   async (payload, { rejectWithValue, getState, dispatch }) => {
//     ;
//     try {
//       const response = await HRServices.hrService().GetEmployeeCadrePosition(payload);
//       return response.data;
//     } catch (error) {
//       toast.error(error?.response?.data.statusMessage);
//       return rejectWithValue(error?.response?.data);
//     }
//   }
// );

export const DeleteOvertimeType = createAsyncThunk(
  "hr/deleteOvertimeType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    console.log(payload);
    try {
      const response = await HRServices.hrService().DeleteOvertimeType(payload);
      console.log(response);

      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const CreateOvertimeType = createAsyncThunk(
  "hr/createOvertimeType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateOvertimeType(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const UpdateOvertimeType = createAsyncThunk(
  "hr/updateOvertimeType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateOvertimeType(payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//end overtime setup

//start overtime requisition

export const GetOvertimeRequisition = createAsyncThunk(
  "hr/getOvertimeRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetOvertimeRequisition(
        payload
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllOvertimeRequisition = createAsyncThunk(
  "hr/getAllOvertimeRequisition",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await HRServices.hrService().GetAllOvertimeRequisition(
        payload
      );

      // console.log(response)
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllOvertimeRequisitionHOD = createAsyncThunk(
  "hr/getAllOvertimeRequisition",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await HRServices.hrService().GetAllOvertimeRequisitionWorkflow(payload);

      // console.log(response)
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllOvertimeRequisitionEDS = createAsyncThunk(
  "hr/getAllOvertimeRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetAllOvertimeRequisitionWorkflow(payload);

      // console.log(response)
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateOvertime = createAsyncThunk(
  "hr/createOvertime",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateOvertime(payload);

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateOvertime = createAsyncThunk(
  "hr/updateOvertime",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    console.log(payload);
    try {
      const response = await HRServices.hrService().UpdateOvertime(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelOvertime = createAsyncThunk(
  "hr/cancelOvertimeRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CancelOvertimeRequisition(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleOvertime = createAsyncThunk(
  "hr/singleOvertimeRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.hrService().GetSingleOvertimeRequisition(payload);

      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const ApproveOvertimeRequest = createAsyncThunk(
  "hr/approveOvertimeRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveOvertimeRequest(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const DeclineOvertimeRequest = createAsyncThunk(
  "hr/declineOvertimeRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineOvertimeRequest(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveOvertimeRequestBulk = createAsyncThunk(
  "hr/approveOvertimeRequestBulk",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveOvertimeRequestBulk(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineOvertimeRequestBulk = createAsyncThunk(
  "hr/declineOvertimeRequestBulk",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineOvertimeRequestBulk(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveDeclineBatchOvertimeRequestBulk = createAsyncThunk(
  "hr/approveDeclineBatchOvertimeRequestBulk",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveDeclineBatchOvertimeRequestBulk(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//end overtime requisition

//start employee update
export const GetEmployees = createAsyncThunk(
  "hr/getemployee",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEmployee(payload);
      //console.log(response)
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const GetEmployeeById = createAsyncThunk(
  "hr/getemployeeById",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEmployeeById(payload);
      //console.log(response)
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateEmployeeInformation = createAsyncThunk(
  "hr/updateEmployeeInfo",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().UpdateEmployeInformation(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetEmployeeBeneficiary = createAsyncThunk(
  "hr/getemployeebeneficiary",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEmployeeBeneficiary(
        payload
      );
      //console.log(response)
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveEmployeeBeneficiary = createAsyncThunk(
  "hr/approveEmployeeBeneficiary",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().ApproveEmployeeBeneficiary(
        payload
      );
      console.log(response);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeBeneficiary = createAsyncThunk(
  "hr/declineEmployeeBeneficiary",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().DeclineEmployeeBeneficiary(
        payload
      );
      console.log(response);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllEmployeeBeneficiary = createAsyncThunk(
  "hr/Employeebeneficiaries",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetAllEmployeeBeneficiary(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateEmployeeBeneficiary = createAsyncThunk(
  "hr/createEmployeeBeneficiary",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().CreateEmployeBeneficiary(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetEmployeeDesignation = createAsyncThunk(
  "hr/getEmployeeDesignation",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEmployeeDesignation(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetEmployeeQualifications = createAsyncThunk(
  "hr/getEmployeeQualification",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEmployeeQualifications(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetEmployeeExtendedClaims = createAsyncThunk(
  "hr/getEmployeeClaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.hrService().GetEmployeeExtendedClaims(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const ApproveEmployeeInformation = createAsyncThunk(
  "hr/ApproveInformation",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().ApproveEmployeeInformation(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      } else {
        toast.error(response?.data?.statusMessage);
      }
      return response?.data;
    } catch (error) {
      console.log("error", error);
      toast.error(error?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeInformation = createAsyncThunk(
  "hr/DeclineInformation",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().DeclineEmployeeInformation(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      } else {
        toast.error(response?.data?.statusMessage);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveEmployeeNOK = createAsyncThunk(
  "hr/ApproveNOK",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().ApproveEmployeeNOK(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeNOK = createAsyncThunk(
  "hr/DeclineNOK",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().DeclineEmployeeNOK(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveEmployeeQualification = createAsyncThunk(
  "hr/ApproveQualification",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response =
        await HRServices.hrService().ApproveEmployeeQualification(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeQualification = createAsyncThunk(
  "hr/DeclineQualification",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response =
        await HRServices.hrService().DeclineEmployeeQualification(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveEmployeeReferee = createAsyncThunk(
  "hr/ApproveReferee",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().ApproveEmployeeReferee(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeReferee = createAsyncThunk(
  "hr/DeclineReferee",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().DeclineEmployeeReferee(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveEmployeeClaims = createAsyncThunk(
  "hr/approveClaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().ApproveEmployeeClaims(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineEmployeeClaims = createAsyncThunk(
  "hr/Declineclaims",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // console.log(payload)
      const response = await HRServices.hrService().DeclineEmployeeClaims(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Start of Training Requisition

export const CreateTrainingRequisition = createAsyncThunk(
  "hr/CreateTrainingRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.trainingRequisition().CreateRequisition(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateTrainingBeneficiary = createAsyncThunk(
  "hr/CreateTrainingBeneficiary",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.trainingRequisition().CreateBeneficiary(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateTrainingBeneficiary = createAsyncThunk(
  "hr/CreateTrainingBeneficiary",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.trainingRequisition().UpdateBeneficiary(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateTrainingRequisition = createAsyncThunk(
  "hr/CreateTrainingRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.trainingRequisition().UpdateRequisition(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllEmployeesTrainingRequisitions = createAsyncThunk(
  "hr/GetAllEmployeesTrainingRequisitions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.trainingRequisition().GetAllEmployeeTraining(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data?.responseObject;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetEmployeeTrainingRequisition = createAsyncThunk(
  "hr/GetEmployeeTrainingRequisitions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.trainingRequisition().GetEmployeeTrainingRequisition(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data?.responseObject;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveTrainingRequest = createAsyncThunk(
  "hr/ApproveRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.trainingRequisition().ApproveRequisition(payload);

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineTrainingRequest = createAsyncThunk(
  "hr/DeclineRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await HRServices.trainingRequisition().DeclineRequisition(payload);

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CancelTrainingRequest = createAsyncThunk(
  "hr/CancelRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.trainingRequisition().CancelRequisition(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DisableCreditFacility = createAsyncThunk(
  "hr/CancelRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //console.log(payload)
      const response = await HRServices.hrService().DisableCreditFacility(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveOrDeclineBatchTrainingRequest = createAsyncThunk(
  "hr/ApproveRequest",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    console.log(payload);
    try {
      const response =
        await HRServices.trainingRequisition().ApproveOrDeclineBatchEmployeeTrainingRequest(
          payload
        );
      console.log(response);

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Start of Training Setup

export const CreateTrainingType = createAsyncThunk(
  "hr/CreateTrainingType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.trainingSetup().CreateTrainingType(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllTrainingType = createAsyncThunk(
  "hr/GetAllTrainingType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.trainingSetup().GetAllTrainingType(
        payload
      );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateTrainingType = createAsyncThunk(
  "hr/CreateTrainingType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.trainingSetup().UpdateTrainingType(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteTrainingType = createAsyncThunk(
  "hr/DeleteTrainingType",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await HRServices.trainingSetup().DeleteTrainingType(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  hr: "",
  document_definition: null, // Make sure this field exists
  isLoading: false, // Ensure this is initialized
  error: null, // Handle errors properly
};
console.log("initial state", initialState);
export const HRSlice = createSlice({
  name: "hr",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(GetRSA.pending, (state) => {
        return {
          ...state,
          isLoadingRsa: true,
        };
      })
      .addCase(GetRSA.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingRsa: false,
          isSuccessful: true,
          get_RSA: action.payload,
        };
      })
      .addCase(GetRSA.rejected, (state, action) => {
        return {
          ...state,
          isLoadingRsa: false,
          error: action.payload,
        };
      });

    builder.addCase(GetAllPayroll.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllPayroll.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_payroll: payload,
      };
    });
    builder.addCase(GetAllPayroll.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSinglePayroll.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetSinglePayroll.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_request: payload,
      };
    });

    builder.addCase(GetSinglePayroll.rejected, (state, { payload }) => {
      return {
        ...state,
        error: payload,
      };
    });

    builder.addCase(GetAllLoanRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllLoanRequisition.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_loanrequisition: payload,
      };
    });
    builder.addCase(GetAllLoanRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleLoanRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(
      GetSingleLoanRequisition.fulfilled,
      (state, { payload }) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          single_loanrequisition: payload,
        };
      }
    );
    builder.addCase(GetSingleLoanRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleEmployeeCadrePosition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(
      GetSingleEmployeeCadrePosition.fulfilled,
      (state, { payload }) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          get_requestemployeecadre: payload,
        };
      }
    );

    builder.addCase(
      GetSingleEmployeeCadrePosition.rejected,
      (state, { payload }) => {
        return {
          ...state,
          error: payload,
        };
      }
    );

    builder.addCase(
      GetSingleEmployeeCadrePositionLevel.pending,
      (state, action) => {
        return {
          ...state,
          isLoading: true,
        };
      }
    );

    builder.addCase(
      GetSingleEmployeeCadrePositionLevel.fulfilled,
      (state, { payload }) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          get_requestemployeecadrelevel: payload,
        };
      }
    );

    builder.addCase(
      GetSingleEmployeeCadrePositionLevel.rejected,
      (state, { payload }) => {
        return {
          ...state,
          error: payload,
        };
      }
    );

    builder.addCase(GetLoanSetup.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetLoanSetup.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        loan_setup: payload,
      };
    });
    builder.addCase(GetLoanSetup.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetLoanRuleSetup.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetLoanRuleSetup.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        loan_rulesetup: payload,
      };
    });
    builder.addCase(GetLoanRuleSetup.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeGroup.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetEmployeeGroup.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_employeegroup: payload,
      };
    });
    builder.addCase(GetEmployeeGroup.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetExtendedHMOClaims.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetExtendedHMOClaims.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_extendedhmoclaims: payload,
      };
    });
    builder.addCase(GetExtendedHMOClaims.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleExtendedHMOClaims.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(
      GetSingleExtendedHMOClaims.fulfilled,
      (state, { payload }) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          get_singleextendedhmoclaims: payload,
        };
      }
    );
    builder.addCase(GetSingleExtendedHMOClaims.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(ApproveEmployeeGroup.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(ApproveEmployeeGroup.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        approve_employeegroup: action.payload,
      };
    });
    builder.addCase(ApproveEmployeeGroup.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(DeclineEmployeeGroup.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(DeclineEmployeeGroup.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        decline_employeegroup: action.payload,
      };
    });

    builder.addCase(CancelEmployeeGroup.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(CancelEmployeeGroup.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        cancel_employeegroup: payload,
      };
    });

    builder.addCase(CancelEmployeeGroup.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAttendanceClock.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAttendanceClock.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_attendanceclock: payload,
      };
    });
    builder.addCase(GetAttendanceClock.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    // builder
    //   .addCase(GetAllPayroll.pending, (state) => {
    //     return {
    //       ...state,
    //       isLoadingPayroll: true,
    //     };
    //   })
    //   .addCase(GetAllPayroll.fulfilled, (state, action) => {
    //     return {
    //       ...state,
    //       isLoadingPayroll: false,
    //       isSuccessful: true,
    //       all_payroll: action.payload,
    //     };
    //   })
    //   .addCase(GetAllPayroll.rejected, (state, action) => {
    //     return {
    //       ...state,
    //       isLoadingPayroll: false,
    //       error: action.payload,
    //     };
    //   });

    builder.addCase(ApprovePayroll.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(ApprovePayroll.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        approve_payroll: action.payload,
      };
    });
    builder.addCase(ApprovePayroll.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(DeclinePayroll.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(DeclinePayroll.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        decline_payroll: action.payload,
      };
    });

    builder.addCase(CancelPayroll.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(CancelPayroll.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        cancel_payroll: payload,
      };
    });

    builder.addCase(CancelPayroll.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder
      .addCase(GetAllEmployees.pending, (state) => {
        return {
          ...state,
          isLoadingEmployees: true,
        };
      })
      .addCase(GetAllEmployees.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingEmployees: false,
          isSuccessful: true,
          all_employees: action.payload,
        };
      })
      .addCase(GetAllEmployees.rejected, (state, action) => {
        return {
          ...state,
          isLoadingEmployees: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetEmployees.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetEmployees.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          employees: action.payload,
        };
      })
      .addCase(GetEmployees.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetEmployeeById.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })

      .addCase(GetEmployeeById.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          employee: action.payload,
        };
      })

      .addCase(GetEmployeeById.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });

    builder.addCase(GetLeaveTypes.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetLeaveTypes.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        leave_types: action.payload,
      };
    });

    builder.addCase(GetLeaveTypes.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetLeaveReasons.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetLeaveReasons.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        leave_reasons: action.payload,
      };
    });

    builder.addCase(GetLeaveReasons.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllDepartments.pending, (state, action) => {
      return {
        ...state,
        isLoadingDepartment: true,
      };
    });
    builder.addCase(GetAllDepartments.fulfilled, (state, action) => {
      return {
        ...state,
        isLoadingDepartment: false,
        isSuccessful: true,
        all_departments: action.payload,
      };
    });

    builder.addCase(GetAllDepartments.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetUnits.pending, (state, action) => {
      return {
        ...state,
        isLoadingUnit: true,
      };
    });
    builder.addCase(GetUnits.fulfilled, (state, action) => {
      return {
        ...state,
        isLoadingUnit: false,
        isSuccessful: true,
        units: action.payload,
      };
    });

    builder.addCase(GetUnits.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleLeaveRequest.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleLeaveRequest.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_request: action.payload,
      };
    });

    builder.addCase(GetSingleLeaveRequest.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetMyLeaveRequest.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetMyLeaveRequest.fulfilled, (state, action) => {
      return {
        ...state,
        isLoadingAction: false,
        isSuccessful: true,
        get_myrequest: action.payload,
      };
    });

    builder.addCase(GetAllLeaveRequest.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllLeaveRequest.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllLeaveRequest.fulfilled, (state, action) => {
      return {
        ...state,
        isLoadingAction: false,
        isSuccessful: true,
        all_request: action.payload,
      };
    });

    builder.addCase(GetMyLeaveRequest.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetByDepartment.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetByDepartment.fulfilled, (state, action) => {
      return {
        ...state,
        isLoadingAction: false,
        isSuccessful: true,
        get_department: action.payload,
      };
    });

    builder.addCase(GetByDepartment.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleDepartment.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleDepartment.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_dept: action.payload,
      };
    });

    builder.addCase(GetSingleDepartment.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleLeaveRecall.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleLeaveRecall.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_recall: action.payload,
      };
    });

    builder.addCase(GetSingleLeaveRecall.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetConfirmAction.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetConfirmAction.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_confirmation: action.payload,
      };
    });

    builder.addCase(GetConfirmAction.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetExitRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetExitRequisition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_exit: action.payload,
      };
    });

    builder.addCase(GetExitRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetExitRequisitionHOD.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetExitRequisitionHOD.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_exithod: action.payload,
      };
    });

    builder.addCase(GetExitRequisitionHOD.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetMyExitRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetMyExitRequisition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_my_exit: action.payload,
      };
    });

    builder.addCase(GetMyExitRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });
    builder.addCase(GetSingleExitRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleExitRequisition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_single_exit: action.payload,
      };
    });

    builder.addCase(GetSingleExitRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetExitDiscussionQuestion.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetExitDiscussionQuestion.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_discussion_question: action.payload,
      };
    });

    builder.addCase(GetExitDiscussionQuestion.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetExistDiscussionById.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetExistDiscussionById.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_discussion_by_id: action.payload,
      };
    });

    builder.addCase(GetExitDiscussion.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetExitDiscussion.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_discussion: action.payload,
      };
    });

    builder.addCase(GetExitDiscussion.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetQuerySetup.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetQuerySetup.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_querysetup: action.payload,
      };
    });
    builder.addCase(GetQuerySetup.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });
    builder.addCase(GetOvertimeType.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetOvertimeType.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_overtime_type: action.payload,
      };
    });
    builder.addCase(GetOvertimeType.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeCadrePosition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetEmployeeCadrePosition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        cadre_position: action.payload,
      };
    });
    builder.addCase(GetEmployeeCadrePosition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeCadreLevels.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetEmployeeCadreLevels.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        cadre_levels: action.payload,
      };
    });

    builder.addCase(GetEmployeeCadreLevels.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(ApproveEmployeeCadrePosition.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(ApproveEmployeeCadrePosition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        approve_employeecadreposition: action.payload,
      };
    });
    builder.addCase(ApproveEmployeeCadrePosition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(DeclineEmployeeCadrePosition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(DeclineEmployeeCadrePosition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        decline_employeecadreposition: action.payload,
      };
    });

    builder.addCase(CancelEmployeeCadrePosition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(
      CancelEmployeeCadrePosition.fulfilled,
      (state, { payload }) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          cancel_employeecadreposition: payload,
        };
      }
    );

    builder.addCase(CancelEmployeeCadrePosition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeCadrePositionLevel.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(
      GetEmployeeCadrePositionLevel.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          cadre_positionlevel: action.payload,
        };
      }
    );
    builder.addCase(GetEmployeeCadrePositionLevel.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(ApproveEmployeeCadrePositionLevel.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(
      ApproveEmployeeCadrePositionLevel.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          approve_employeecadrepositionlevel: action.payload,
        };
      }
    );
    builder.addCase(
      ApproveEmployeeCadrePositionLevel.rejected,
      (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      }
    );

    builder.addCase(
      DeclineEmployeeCadrePositionLevel.pending,
      (state, action) => {
        return {
          ...state,
          isLoading: true,
        };
      }
    );
    builder.addCase(
      DeclineEmployeeCadrePositionLevel.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          decline_employeecadrepositionlevel: action.payload,
        };
      }
    );

    builder.addCase(
      CancelEmployeeCadrePositionLevel.pending,
      (state, action) => {
        return {
          ...state,
          isLoading: true,
        };
      }
    );
    builder.addCase(
      CancelEmployeeCadrePositionLevel.fulfilled,
      (state, { payload }) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          cancel_employeecadrepositionlevel: payload,
        };
      }
    );

    builder.addCase(
      CancelEmployeeCadrePositionLevel.rejected,
      (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      }
    );

    builder.addCase(GetDepartment.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetDepartment.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_department: action.payload,
      };
    });
    builder.addCase(GetDepartment.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetPayrollStructure.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetPayrollStructure.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        payroll_structure: action.payload,
      };
    });
    builder.addCase(GetPayrollStructure.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(ApprovePayrollStructure.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(ApprovePayrollStructure.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        approve_payrollstructure: action.payload,
      };
    });
    builder.addCase(ApprovePayrollStructure.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(DeclinePayrollStructure.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(DeclinePayrollStructure.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        decline_payrollstructure: action.payload,
      };
    });

    builder.addCase(CancelPayrollStructure.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(CancelPayrollStructure.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        cancel_payrollstructure: payload,
      };
    });

    builder.addCase(CancelPayrollStructure.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSinglePayrollStructure.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(
      GetSinglePayrollStructure.fulfilled,
      (state, { payload }) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          get_requestpayrollstructure: payload,
        };
      }
    );

    builder.addCase(
      GetSinglePayrollStructure.rejected,
      (state, { payload }) => {
        return {
          ...state,
          error: payload,
        };
      }
    );

    builder.addCase(GetAllHospital.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllHospital.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_allhospital: action.payload,
      };
    });
    builder.addCase(GetAllHospital.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleHospital.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleHospital.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_singlehospital: action.payload,
      };
    });
    builder.addCase(GetSingleHospital.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllMedicalLimit.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllMedicalLimit.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_medicallimit: action.payload,
      };
    });
    builder.addCase(GetAllMedicalLimit.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleMedicalLimit.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleMedicalLimit.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_singlemedicallimit: action.payload,
      };
    });
    builder.addCase(GetSingleMedicalLimit.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetJobTitle.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetJobTitle.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        job_title: action.payload,
      };
    });
    builder.addCase(GetJobTitle.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetJobListing.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetJobListing.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        job_listing: action.payload,
      };
    });

    builder.addCase(GetJobListing.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    // GetSingleJobListing
    builder.addCase(GetSingleJobListing.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetSingleJobListing.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_singlejoblisting: payload,
      };
    });

    builder.addCase(GetSingleJobListing.rejected, (state, { payload }) => {
      return {
        ...state,
        error: payload,
      };
    });

    // GetJobOffer
    builder.addCase(GetJobOffer.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetJobOffer.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        job_offer: action.payload,
      };
    });

    builder.addCase(GetJobOffer.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleJobTitle.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetSingleJobTitle.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_singlejobtitle: payload,
      };
    });

    builder.addCase(GetSingleJobTitle.rejected, (state, { payload }) => {
      return {
        ...state,
        error: payload,
      };
    });

    builder.addCase(GetSkills.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSkills.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_skills: action.payload,
      };
    });
    builder.addCase(GetSkills.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleSkill.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetSingleSkill.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_singleskill: payload,
      };
    });

    builder.addCase(GetSingleSkill.rejected, (state, { payload }) => {
      return {
        ...state,
        error: payload,
      };
    });

    builder.addCase(GetQualifications.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetQualifications.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_qualifications: action.payload,
      };
    });
    builder.addCase(GetQualifications.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleQualification.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetSingleQualification.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_singlequalification: payload,
      };
    });

    builder.addCase(GetSingleQualification.rejected, (state, { payload }) => {
      return {
        ...state,
        error: payload,
      };
    });

    builder.addCase(GetMetrics.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetMetrics.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_metrics: action.payload,
      };
    });
    builder.addCase(GetMetrics.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleMetrics.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetSingleMetrics.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_singlemetrics: payload,
      };
    });

    builder.addCase(GetSingleMetrics.rejected, (state, { payload }) => {
      return {
        ...state,
        error: payload,
      };
    });

    builder.addCase(GetApplication.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetApplication.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_application: action.payload,
      };
    });
    builder.addCase(GetApplication.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleApplication.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetSingleApplication.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_singleapplication: payload,
      };
    });

    builder.addCase(GetSingleApplication.rejected, (state, { payload }) => {
      return {
        ...state,
        error: payload,
      };
    });

    builder.addCase(GetOvertimeRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetOvertimeRequisition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_overtime: action.payload,
      };
    });
    builder.addCase(GetOvertimeRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllOvertimeRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllOvertimeRequisition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_all_overtime: action.payload,
      };
    });
    builder.addCase(GetAllOvertimeRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleOvertime.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleOvertime.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_single_overtime: action.payload,
      };
    });
    builder.addCase(GetSingleOvertime.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetQueries.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetQueries.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_queries: action.payload,
      };
    });

    builder.addCase(GetQueries.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetQueryManagement.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetQueryManagement.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_query_management: action.payload,
      };
    });

    builder.addCase(GetQueryManagement.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleQuery.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleQuery.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        single_query: action.payload,
      };
    });

    builder.addCase(GetSingleQuery.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleQueryManagement.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleQueryManagement.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        single_query_management: action.payload,
      };
    });

    builder.addCase(GetSingleQueryManagement.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeBeneficiary.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetEmployeeBeneficiary.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        employee_beneficiary: action.payload,
      };
    });

    builder.addCase(GetEmployeeBeneficiary.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllEmployeeBeneficiary.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllEmployeeBeneficiary.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_beneficiary: action.payload,
      };
    });

    builder.addCase(GetAllEmployeeBeneficiary.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeDesignation.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetEmployeeDesignation.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_designation: action.payload,
      };
    });

    builder.addCase(GetEmployeeDesignation.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeMedicalRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(
      GetEmployeeMedicalRequisition.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          get_medicalrequisition: action.payload,
        };
      }
    );

    builder.addCase(GetEmployeeMedicalRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(
      GetSingleEmployeeMedicalRequisition.pending,
      (state, action) => {
        return {
          ...state,
          isLoading: true,
        };
      }
    );
    builder.addCase(
      GetSingleEmployeeMedicalRequisition.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          getsingle_medicalrequisition: action.payload,
        };
      }
    );

    // ********************************

    builder.addCase(GetMyWeekendAllowance.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetMyWeekendAllowance.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        my_weekend_allowance: action.payload,
      };
    });

    builder.addCase(GetMyWeekendAllowance.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(getSingleWeekendAllowance.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(getSingleWeekendAllowance.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        single_weekend_allowance: action.payload,
      };
    });

    builder.addCase(getSingleWeekendAllowance.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllWeekendAllowance.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetAllWeekendAllowance.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_weekend_allowance: action.payload,
      };
    });

    builder.addCase(GetAllWeekendAllowance.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllWeekendAllowanceSetup.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetAllWeekendAllowanceSetup.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_weekend_allowance_setup: action.payload,
      };
    });

    builder.addCase(GetAllWeekendAllowanceSetup.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    // ************  Repayment Plan Setup **************
    builder.addCase(GetAllRepaymentPlanSetup.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetAllRepaymentPlanSetup.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_repayment_plan_setup: action.payload,
      };
    });

    builder.addCase(GetAllRepaymentPlanSetup.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetRepaymentPlanSetupById.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetRepaymentPlanSetupById.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        repayment_plan_setup_by_id: action.payload,
      };
    });

    builder.addCase(GetRepaymentPlanSetupById.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllAuxiliaryServiceSetup.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetAllAuxiliaryServiceSetup.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        auxiliary_service_setup: action.payload,
      };
    });

    builder.addCase(GetAllAuxiliaryServiceSetup.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAuxiliaryServiceSetupById.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetAuxiliaryServiceSetupById.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        auxiliary_service_setup_by_id: action.payload,
      };
    });

    builder.addCase(GetAuxiliaryServiceSetupById.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    // ************ Auxiliary Service Request **************

    builder.addCase(GetAllAuxiliaryServiceRequest.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(
      GetAllAuxiliaryServiceRequest.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          all_auxiliary_service_request: action.payload,
        };
      }
    );

    builder.addCase(GetAllAuxiliaryServiceRequest.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAuxiliaryServiceRequestById.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(
      GetAuxiliaryServiceRequestById.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          auxiliary_service_request_by_id: action.payload,
        };
      }
    );

    builder.addCase(
      GetAuxiliaryServiceRequestById.rejected,
      (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      }
    );

    // ************************************

    builder.addCase(
      GetSingleEmployeeMedicalRequisition.rejected,
      (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      }
    );

    builder.addCase(GetDirectorate.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetDirectorate.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_directorate: action.payload,
      };
    });

    builder.addCase(GetDirectorate.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleDirectorate.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleDirectorate.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        getsingle_directorate: action.payload,
      };
    });

    builder.addCase(GetSingleDirectorate.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetPaymentRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetPaymentRequisition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_paymentrequisition: action.payload,
      };
    });

    builder.addCase(GetPaymentRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetPaymentRequisitionWorkflow.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(
      GetPaymentRequisitionWorkflow.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          get_paymentrequisition: action.payload,
        };
      }
    );

    builder.addCase(GetPaymentRequisitionWorkflow.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetControlPaymentRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetControlPaymentRequisition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_paymentrequisition: action.payload,
      };
    });

    builder.addCase(GetControlPaymentRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSinglePaymentRequisition.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSinglePaymentRequisition.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        getsingle_paymentrequisition: action.payload,
      };
    });

    builder.addCase(GetSinglePaymentRequisition.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetApplicant.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetApplicant.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_applicant: action.payload,
      };
    });

    builder.addCase(GetApplicant.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetSingleApplicant.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetSingleApplicant.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        getsingle_applicant: action.payload,
      };
    });

    builder.addCase(GetSingleApplicant.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeQualifications.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetEmployeeQualifications.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_qualification: action.payload,
      };
    });

    builder.addCase(GetEmployeeQualifications.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeExtendedClaims.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetEmployeeExtendedClaims.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_claims: action.payload,
      };
    });

    builder.addCase(GetEmployeeExtendedClaims.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllReferees.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllReferees.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        all_referees: action.payload,
      };
    });

    builder.addCase(GetAllReferees.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllEmployeesTrainingRequisitions.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(
      GetAllEmployeesTrainingRequisitions.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          all_emp_req: action.payload,
        };
      }
    );
    builder.addCase(
      GetAllEmployeesTrainingRequisitions.rejected,
      (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      }
    );

    builder.addCase(GetAllTrainingType.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllTrainingType.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        all_training_type: action.payload,
      };
    });
    builder.addCase(GetAllTrainingType.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetEmployeeTrainingRequisition.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(
      GetEmployeeTrainingRequisition.fulfilled,
      (state, action) => {
        return {
          ...state,
          isLoading: false,
          emp_req: action.payload,
        };
      }
    );
    builder.addCase(
      GetEmployeeTrainingRequisition.rejected,
      (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      }
    );

    builder.addCase(getAllQueryAssetDamage.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(getAllQueryAssetDamage.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        all_query_asset_damage: action.payload,
      };
    });

    builder.addCase(getAllQueryAssetDamage.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(getSingleQueryAssetDamage.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(getSingleQueryAssetDamage.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        single_query_asset_damage: action.payload,
      };
    });

    builder.addCase(getSingleQueryAssetDamage.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(updateQueryAssetDamage.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(updateQueryAssetDamage.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        update_query_asset_damage: action.payload,
      };
    });

    builder.addCase(updateQueryAssetDamage.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetAllBookingService.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetAllBookingService.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        all_booking_service: action.payload,
      };
    });

    builder.addCase(GetAllBookingService.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetBookingServiceById.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(GetBookingServiceById.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        booking_service_by_id: action.payload,
      };
    });

    builder.addCase(GetBookingServiceById.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });

    builder.addCase(GetDocumentDifinition.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(GetDocumentDifinition.fulfilled, (state, action) => {
      console.log(action.payload, "fulfilled");
      state.document_definition = action.payload;
      state.isLoading = false;
    });

    builder.addCase(GetDocumentDifinition.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });

    // builder.addCase(GetDocumentDifinition.pending, (state) => {
    //   return {
    //     ...state,
    //     isLoading: true,
    //   };
    // });

    // builder.addCase(GetDocumentDifinition.fulfilled, (state, action) => {
    //   console.log(action.payload, "fulfilled");
    //   state.document_definition = action.payload;
    //   state.isLoading = false;
    //   // return {
    //   //   ...state,
    //   //   isLoading: false,
    //   //   document_definition: action.payload,
    //   // };
    // });

    // builder.addCase(GetDocumentDifinition.rejected, (state, action) => {
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };
    // });
  },
});

export default HRSlice.reducer;
